var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = { class: "w-full p-7" };
var _hoisted_2 = { class: "text-3xl text-center font-bold" };
var _hoisted_3 = { class: "mt-5 text-gray-400 flex justify-center items-center" };
var _hoisted_4 = { class: "font-normal" };
var _hoisted_5 = {
    class: "hover:underline",
    href: "/docs/policy",
    target: "_blank"
};
var _hoisted_6 = {
    class: "hover:underline",
    href: "/docs/oferta",
    target: "_blank"
};
import { useI18n } from 'vue-i18n';
import { apiErrorsHandle } from '@common/utils/Helpers/Helpers';
import getClientFingerprint from '@common/utils/ClientFingerprint';
import { AuthModalStore } from '@student/modules/store';
import Auth from '@common/modules/auth';
import { useForm } from 'vee-validate';
import { toTypedSchema } from '@vee-validate/zod';
import { z } from 'zod';
import { computed, ref } from 'vue';
import EInputField from '@common/ui/EForm/fields/EInputField.vue';
import ECheckboxField from '@common/ui/EForm/fields/ECheckboxField.vue';
import EButton from '@common/ui/EButton.vue';
import { planFeatures } from '@common/utils/Plans';
import { canUseFeature } from '@common/modules/school';
import ELabel from '@common/ui/ELabel.vue';
import EIcon from '@common/ui/EIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AuthModalRegister',
    setup: function (__props) {
        var _this = this;
        var t = useI18n().t;
        var loading = ref(false);
        var _a = useForm({
            validationSchema: toTypedSchema(z.object({
                email: z.string()
                    .min(1, t('validation.emailRequired'))
                    .email({
                    message: t('validation.invalidEmail')
                }),
                password: z.string()
                    .min(1, t('validation.passwordRequired'))
                    .min(8, t('validation.passwordMinLength'))
                    .refine(function (v) { return !/\s/.test(v); }, t('validation.passwordNoSpaces')),
                policy: z.boolean().refine(function (v) { return v; }, t('validation.policyRequired'))
            })),
            initialValues: {
                email: '',
                password: '',
                policy: true,
            }
        }), handleSubmit = _a.handleSubmit, values = _a.values, setValues = _a.setValues;
        var showTreaty = computed(function () { return !window.__passdata.dontUseDogovor; });
        var canUseMosruAuth = computed(function () { return canUseFeature(planFeatures.AUTH_PROVIDER_MOSRU); });
        var submitForm = handleSubmit(function (values) { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        loading.value = true;
                        _b = (_a = Auth).register;
                        _c = {
                            email: values.email,
                            password: values.password
                        };
                        return [4 /*yield*/, getClientFingerprint()];
                    case 1:
                        _b.apply(_a, [(_c.fingerprint = _d.sent(),
                                _c)])
                            .then(function () {
                            Auth.restoreSavedLocation();
                            loading.value = false;
                            AuthModalStore.hide();
                        })
                            .catch(function (err) {
                            loading.value = false;
                            apiErrorsHandle(err, {
                                'EMAIL_EXISTS': t('errors.emailExists'),
                                'USER_EXISTS': t('errors.emailExists')
                            });
                        });
                        return [2 /*return*/];
                }
            });
        }); });
        var goLogin = function () {
            AuthModalStore.goLogin();
        };
        var goMosruProvider = function () { return __awaiter(_this, void 0, void 0, function () {
            var fingerPrint;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientFingerprint()];
                    case 1:
                        fingerPrint = _a.sent();
                        location.href = "/api/openid/mosru-auth?fingerprint=".concat(fingerPrint, "&returnUrl=").concat(location.href);
                        return [2 /*return*/];
                }
            });
        }); };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)('registration.title')), 1),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('registration.alreadyRegistered')), 1),
                    _createVNode(EButton, {
                        class: "text-primary hover:underline ml-1",
                        size: "nosize",
                        type: "text",
                        onClick: goLogin
                    }, {
                        default: _withCtx(function () { return [
                            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('registration.login')), 1)
                        ]; }),
                        _: 1
                    })
                ]),
                _createVNode(ELabel, {
                    label: _unref(t)('registration.emailOrLogin'),
                    class: "mt-5",
                    weight: "medium"
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(EInputField, {
                            placeholder: _unref(t)('registration.emailPlaceholder'),
                            plugins: ['trim'],
                            name: "email",
                            size: "large",
                            theme: "gray",
                            type: "email",
                            onKeyup: _withKeys(_unref(submitForm), ["enter"])
                        }, null, 8, ["placeholder", "onKeyup"])
                    ]; }),
                    _: 1
                }, 8, ["label"]),
                _createVNode(ELabel, {
                    label: _unref(t)('registration.password'),
                    class: "mt-5",
                    weight: "medium"
                }, {
                    default: _withCtx(function () { return [
                        _createVNode(EInputField, {
                            plugins: ['trim'],
                            name: "password",
                            placeholder: "••••••••",
                            size: "large",
                            theme: "gray",
                            type: "password",
                            autocomplete: "",
                            onKeyup: _withKeys(_unref(submitForm), ["enter"])
                        }, null, 8, ["onKeyup"])
                    ]; }),
                    _: 1
                }, 8, ["label"]),
                _createVNode(ECheckboxField, {
                    class: "mt-4",
                    name: "policy"
                }, {
                    default: _withCtx(function () { return [
                        _createTextVNode(_toDisplayString(_unref(t)('registration.agreeTo')) + " ", 1),
                        _createElementVNode("a", _hoisted_5, _toDisplayString(_unref(t)('registration.privacyPolicy')), 1),
                        (showTreaty.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_unref(t)('registration.and')) + " ", 1),
                                _createElementVNode("a", _hoisted_6, _toDisplayString(_unref(t)('registration.offerAgreement')), 1)
                            ], 64))
                            : _createCommentVNode("", true)
                    ]; }),
                    _: 1
                }),
                _createVNode(EButton, {
                    loading: loading.value,
                    class: "mt-4 w-full",
                    size: "large",
                    type: "primary",
                    onClick: _unref(submitForm)
                }, {
                    default: _withCtx(function () { return [
                        _createTextVNode(_toDisplayString(_unref(t)('registration.createAccount')), 1)
                    ]; }),
                    _: 1
                }, 8, ["loading", "onClick"]),
                (canUseMosruAuth.value)
                    ? (_openBlock(), _createBlock(EButton, {
                        key: 0,
                        class: "w-full mt-5",
                        size: "large",
                        type: "green-alt",
                        onClick: goMosruProvider
                    }, {
                        default: _withCtx(function () { return [
                            _createVNode(EIcon, {
                                class: "w-5 h-5 mr-2",
                                icon: "logo-mosru"
                            }),
                            _createElementVNode("span", null, _toDisplayString(_unref(t)('registration.loginWithMosru')), 1)
                        ]; }),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
